module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0001-f07fb3d47426965961ef4bb8bcb1741d.png";